import { useEffect, useState } from "react";
import { useStepNavigate } from "../hooks/useStepNavigate";
import { dataService } from "../services/dataService";
import { useOrder } from "../context/OrderContext";
import TablerLayout from "../components/layout/TablerLayout";
import StepperNavButton from "../components/stepper/StepperNavButton";
import { showErrorToast } from "../components/toasts/ToastService";
import ShoeLoader from "../components/loaders/ShoeLoader";

const MeretfelveteliHely = () => {
	const { order, updateOrder, replaceOrder, resetOrder } = useOrder();
	const navigate = useStepNavigate();
	const [locations, setLocations] = useState([]);
	const [loading, setLoading] = useState(true);
	const [isProcessing, setIsProcessing] = useState(false);

	useEffect(() => {
		let isMounted = true;
		const fetchLocations = async () => {
			try {
				const response = await dataService.getLocations();
				if (isMounted) {
					setLocations(response.data.data);
				}
			} catch (error) {
				if (isMounted) {
					showErrorToast("Nem sikerült betölteni a helyszíneket.");
					console.error("Hiba a helyszínek betöltésekor:", error);
				}
			} finally {
				if (isMounted) {
					setLoading(false);
				}
			}
		};
		fetchLocations();
		return () => {
			isMounted = false;
		};
	}, []);

	useEffect(() => {
		console.log("Rendelés adatok:", order);
	}, [order]);

	const handleLocationClick = async (location) => {
		setIsProcessing(true);
		try {
			console.log("Kiválasztott location:", location);
			const safe_prefix = btoa(unescape(encodeURIComponent(location.depot_prefix)))
				.replace(/\+/g, "-")
				.replace(/\//g, "_")
				.replace(/=+$/, "");
			const response = await dataService.getNextPrefixNr(safe_prefix);
			console.log("Prefix response:", response);

			if (response.data?.status === "ok") {
				const specific_id = response.data.data;

				updateOrder({
					...order,
					hmeliorder: {
						...order.hmeliorder,
						hmeliorder_depot_szam: location.mmeliparam_szam,
						hmeliorder_depot_prefix: location.depot_prefix,
						hmeliorder_specific_id: specific_id,
					},
				});

				setTimeout(() => {
					navigate("/Meretlap");
				}, 0);
			} else {
				throw new Error("A szerver nem megfelelő választ küldött");
			}
		} catch (error) {
			showErrorToast("Nem sikerült menteni a helyszínt");
			console.error("Hiba:", error);
			if (error.response) {
				console.error("API válasz:", error.response.data);
			}
		} finally {
			setIsProcessing(false);
		}
	};

	const canGoNext = order.hmeliorder.hmeliorder_depot_szam > 1;

	return (
		<TablerLayout title="Kérem, válasszon méretfelvételi helyet!">
			<div className="row justify-content-center">
				<div className="col-md-12 text-center mb-4">
					{loading ? <ShoeLoader /> : <title style={{ marginBottom: "2rem" }}>Válassza ki a méretfelvételi helyet!</title>}

					{loading ? (
						""
					) : (
						<div className="container">
							<div className="row g-3 mb-3">
								{locations
									.filter((location) => location.depot_prefix !== "BETÉT")
									.map((location, index) => (
										<div className="col-12 col-sm-6 col-md-3" key={location.depot_prefix || index}>
											<button 
												onClick={() => handleLocationClick(location)} 
												className="btn btn-primary btn-lg w-100"
												disabled={isProcessing}
											>
												{location.depot_prefix}
											</button>
										</div>
									))}
							</div>

							{locations.some((location) => location.depot_prefix === "BETÉT") && (
								<div className="row g-3">
									<div className="col-12 col-md-6 mx-auto">
										{locations
											.filter((location) => location.depot_prefix === "BETÉT")
											.map((location, index) => {
												const style = {
													backgroundColor: order.hmeliorder.hmeliorder_depot_prefix === "BETÉT" ? "#ffe5b4" : "#f39224ff",
													color: "#FFF",
												};
												return (
													<button 
														key={location.depot_prefix || index} 
														onClick={() => handleLocationClick(location)} 
														className="btn btn-secondary btn-lg w-100" 
														style={style}
														disabled={isProcessing}
													>
														{location.depot_prefix}
													</button>
												);
											})}
									</div>
								</div>
							)}
						</div>
					)}

					{canGoNext && (
						<>
							<StepperNavButton side="right" label="Tovább" onClick={() => navigate("/Meretlap")} disabled={isProcessing} />
						</>
					)}
				</div>
			</div>
		</TablerLayout>
	);
};

export default MeretfelveteliHely;
